
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.469 15.582a.75.75 0 101.062-1.059l-1.062 1.06zM1 8.034l-.531-.53a.75.75 0 000 1.06L1 8.033zm7.531-6.49A.75.75 0 007.47.485l1.062 1.06zM19 8.784a.75.75 0 000-1.5v1.5zm-10.469 5.74l-7-7.02L.47 8.564l7 7.02 1.062-1.06zm-7-5.96l7-7.02L7.47.485l-7 7.02L1.53 8.563zM1 8.783h18v-1.5H1v1.5z"}})])
          )
        }
      }
    